function allowSpecialSymbols(str) {
    return str.replace(/([.?*+^$[\]\\(){}|-])/g, '');
}

export default (term, filter) => {
    const regex = new RegExp(allowSpecialSymbols(filter), 'i');
    return regex.test(term);
}